export const removeUrlSearchParam = (paramName: string) => {
    const url = new URL(location.href);
    url.searchParams.delete(paramName);
    history.replaceState({}, '', url.href);
};
